<template>
  <div class="text-center">
    <v-overlay :value="isLoading" z-index="50">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters ({
      isLoading: 'loader/isLoading'
    }),
  },
}
</script>